// Respuestas en que el backend GUARDÓ el documento (venta o compra) pero falló el
// comprobante electrónico: SRI (600, 601), firma (602), SRI caído (603), dirección del
// establecimiento (604) o cupo / suscripción (802). El cobro o pago que AccountEntry capturó antes de guardar se
// registra igual: la plata ya se movió. Antes se descartaba y la venta quedaba
// POR COBRAR para siempre, porque al refacturar ya no se pide el cobro (H66).
export const SAVED_WITH_RECEIPT_ERROR = [600, 601, 602, 603, 604, 802];

export function documentSavedDespiteReceiptError(response) {
    return !!response
        && SAVED_WITH_RECEIPT_ERROR.includes(response.status)
        && !!response.data
        && response.data.id !== undefined && response.data.id !== null;
}
